import React from "react";
import styleSheet from "./style.module.scss";
import { ChipProps } from "./sy-chip-interface";

type Props = {};

const SyChip = (props: ChipProps) => {
  const { children, type, active, lable = "" } = props;

  return (
    <div className={`${active ? styleSheet.active : styleSheet.inactive}`}>
      {children ? (
        children
      ) : (
        <p className="mb-0 p-2 d-flex justify-content-center">{lable}</p>
      )}
    </div>
  );
};

export default SyChip;
